<template>
  <div class="sumTablelist">
    <el-table
        :data="tableData"
        class="sumTable">
      <template v-for="(tList, index) in dispTableSetList">
        <template v-if="isDisplay(tList, index)">
          <el-table-column
              :key="index"
              :label="tList.label"
              :prop="tList.path"
              :min-width="minColumn(tList.width, index)"
              white-space="nowrap" />
        </template>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'SalesSumTableList',
  props: {
    tableData: {
      type: Array,
      required: true,
      default: () => { return [] }
    },
    displayData: {
      type: Array,
      required: true,
      default: () => { return [] }
    },
    showSelection: {
      type: Boolean,
      default: false
    },
    storePath: {
      type: String,
      default: ''
    },
    minColumnWidth: {
      type: [Number, String],
      default: null
    },
    rowClassName: {
      type: [ String, Function ],
      default: ''
    },
    cellClassName: {
      type: [ String, Function ],
      default: ''
    },
    cellStyle: {
      type: Function,
      default: null
    },
    validateScope: {
      type: String,
      default: null
    },
    spanMethod: {
      type: Function,
      default: null
    },
    canSelectMethod: {
      type: Function,
      default: null
    },
    rowKey: {
      type: String,
      default: ''
    },
    asyncRender: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  asyncComputed: {
    async dispTableSetList () {
      return this.displayData.filter((tList) => this.isShow(tList))
    }
  },
  methods: {
    isDisplay (column, index) {
      // isActiveにより、表示対象外となっている場合、非表示。設定がない場合は表示
      if (('isActive' in column) && !column.isActive) {
        return false
      }
      return true
    },
    isShow (column) {
      // isAvailableにより、表示対象外となっている場合、非表示。設定がない場合は表示
      if (('isAvailable' in column) && !column.isAvailable) {
        return false
      }

      return !column.funcId || this.$isFunctionShown(column.funcId)
    },
    minColumn (width) {
      return width !== null ? width : this.minColumnWidth
    }
  }
}
</script>

<style scoped>
.sumTablelist ::v-deep {
  /* テーブル背景 */
  margin-bottom: 20px;
  table-layout: auto;
  max-width: fit-content;
}

.sumTable ::v-deep th.el-table__cell,
.sumTable ::v-deep td.el-table__cell {
  text-align: right;
}
</style>
